'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var App = require('app');
var i18n = require('utils/i18n');
var MultiInput = require('components/common/views/multi_input_view');
var OOP = require('utils/oop');

module.exports = OOP.extend(
    AbstractFormView,
    {
        template: require('components/devices/templates/groups/group_invite_dialog'),

        ui: {
            edtEmail: '#js-email-input',
        },

        regions: {
            emailInput: '#js-email-region',
        },

        events: {
            'click #js-btn-submit': function () {
                var self = this;
                if (this.allFieldsValid()) {
                    var emailList = this.emailInputView.getItems();
                    $.when(
                        App.request('groups:invite', emailList, _.pluck(this.groups, 'id')).done(function (result) {
                            if (result === undefined) {
                                App.hideModal();
                                if (self.cb) {
                                    self.cb(200);
                                }
                                return;
                            }
                            if (
                                result.status === 400 &&
                                (!result.responseJSON || self.emailInputView.getItems().length > 1)
                            ) {
                                // All invited user are already group members
                                App.hideModal();
                                if (self.cb) {
                                    self.cb(result.status);
                                }
                                return;
                            }
                            self.errors = result;
                            self.render();
                        })
                    );
                }
            },
        },

        childEvents: {
            destroy: function () {
                this.items = this.emailInputView.getItems();
            },
        },

        initialize: function (options) {
            this.items = [];
            this.errors = {};
            var self = this;
            this.base.initialize({
                inputFields: {
                    'js-email': {
                        method: 'callback',
                        validIfNotVisible: true,
                        validationCB: function () {
                            return self.emailInputView.validate();
                        },
                        flashThis: function () {
                            return $('#js-email-input').siblings('.bootstrap-tagsinput');
                        },
                    },
                },
                errors: options.errors,
                formData: options.formData,
            });
            this.groups = options.groups;
            this.cb = options.cb;
        },

        serializeData: function () {
            var data = AbstractFormView.prototype.serializeData.apply(this, arguments);
            data.groups = this.groups;
            data.emailInputConfig = {
                inputList: [],
                name: i18n.TR('E-Mails'),
                selectID: 'js-email-input',
                placeholder: i18n.TR('E-Mail'),
            };

            return data;
        },

        onRender: function () {
            this.initMultiInput();
            this.showChildView('emailInput', this.emailInputView);
        },

        initMultiInput: function () {
            this.emailInputView = MultiInput.GetMultiEmailView({
                items: this.items,
                response: this.errors,
                error500Text: i18n.TR('Die Freigabe der Gruppe ist fehlgeschlagen.'),
                error400Text: i18n.TR('Dieser Nutzer ist bereits Mitglied der Gruppe.'),
            });
        },
    },
    'GroupInviteDialogView'
);
